import { MOOD_ICON } from "../../MoodIcons";

// iOS Safari colours a <button>'s text system-blue by default, and the mood SVGs use stroke=currentColor —
// so wrap in an explicit colour to keep the smiley faces black (Android already inherited black).
export function MoodFace({ k, size = 24, color = "var(--text)" }) {
  const F = MOOD_ICON[k] || MOOD_ICON.neutral;
  return <span style={{ color, display: "inline-flex", lineHeight: 0 }}><F size={size} /></span>;
}
